module.exports = __webpack_public_path__ + "img/qrcode.2351892d.jpg";